import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
/* if you will adjust datepicker settings ->
  read the docs and eat your vegestables bro !
https://bootstrap-datepicker.readthedocs.org/en/latest/options.html*/
import $ from 'jquery'
require('bootstrap-datepicker') 
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.da.js')

export default class Datepicker extends Component {
  componentDidMount() {
    this.$input = $(ReactDOM.findDOMNode(this.refs.datepicker));
    this.$input.datepicker({
      format: 'DD d MM yyyy',
      weekStart: 1,      
      autoclose: true,
      language: 'da-DA',
      calendarWeeks: true,
      todayHighlight: true,
      todayBtn: 'linked'
    }).on('changeDate', this.onDatepickerChange);

    let initDate = this.props.defaultValue ? this.props.defaultValue : new Date();
    this.$input.datepicker('update', initDate);
    this.props.onChange(initDate);
    this.$input.datepicker('show');    
  }
  componentWillUnmount = () => {
    this.$input.datepicker('remove');
  };
  onDatepickerChange = (evt) => {
    this.props.onChange(evt.date);
  };
  render() {
    return (
      <input className="form-control" ref="datepicker" style={{'cursor': 'pointer'}}/>
    );
  }
}

  Datepicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.instanceOf(Date)
  };


// WEBPACK FOOTER //
// ./src/App/Common/datepicker.jsx